import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";
 
const activityTrackerApi = {
  getTaskStatsTypeWise: (payload) => {
    const url = "daily-tracker/v1/stats/getTaskStatsTypeWise";
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
    });
  },
 
  getPhysicalInventoryStats: (payload) => {
    const url = "daily-tracker/v1/task-items/getTaskStatsTypeWise";
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
    });
  },
 
  getTaskStatsForSEL: (payload) => {
    const url = "daily-tracker/v1/task-items/getTaskStatsForSEL";
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
    });
  },
 
  getSELStats: (payload) => {
    const url = "daily-tracker/v1/stats/getSELStats";
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
    });
  },
 
  searchTasks: (payload) => {
    const url = "daily-tracker/v1/tasks/search";
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
      useBaseUrl2: true,
      silent: true,
    });
  },
 
  getquickAssist: () => {
    const url = "quickapp/v1/ticket/getStatusCountMap";
    return request({
      method: HTTP_METHOD.GET,
      url,
 
      useBaseUrl2: true,
    });
  },
  getPendingTasksCount: (payload) => {
    const url = "quickapp/v1/store-communication/tasks/search";
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
      useBaseUrl2: true,
      silent: true,
    });
  },
 
  searchTaskTemplates: (payload) => {
    const url = "quickapp/v1/store-communication/task-templates/search";
    return request({
      method: HTTP_METHOD.POST,
      url,
      data: payload,
      useBaseUrl2: true,
      silent: true,
    });
  },
 
  getLatestUpdateTimeByTaskType: () => {
    const url = "daily-tracker/v1/sync-times/latest";
    return request({
      method: HTTP_METHOD.GET,
      url,
      useBaseUrl2: true,
    });
  },
};
 
export default activityTrackerApi;
 